// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1vYP7","title":"Images90_title__2EWty","images":"Images90_images__1_XoU"};